module.exports = __webpack_public_path__ + "assets/imgs/banners/hero-image-japan.jpg";